// --- Light Mode Image Imports ---
import Four_Chamber_View_of_the_Heart from '../../../assets/iconsPlans/Four_Chamber_View_of_the_Heart.png';
import LVOT from '../../../assets/iconsPlans/LVOT.png';
import RVOT from '../../../assets/iconsPlans/RVOT.png';
import Three_Vessel_View from '../../../assets/iconsPlans/Three_Vessel_View.png';
import Three_Vessel_View_Trachea from '../../../assets/iconsPlans/Three_Vessel_View_Trachea.png';
import Transventricular_View from '../../../assets/iconsPlans/Transventricular_View.png';
import Transthalamic_View from '../../../assets/iconsPlans/Transthalamic_View.png';
import Transcerebellar_View from '../../../assets/iconsPlans/Transcerebellar_View.png';
import Sagittal_View_of_the_Brain from '../../../assets/iconsPlans/Sagittal_View_of_the_Brain.png';
import Sagittal_View_of_the_Face from '../../../assets/iconsPlans/Sagittal_View_of_the_Face.png';
import Coronal_View_of_Upper_Lip_Nose_Nostrils from '../../../assets/iconsPlans/Coronal_View_of_Upper_Lip_Nose_Nostrils.png';
import Sagittal_View_of_the_Entire_Spine from '../../../assets/iconsPlans/Sagittal_View_of_the_Entire_Spine.png';
import Coronal_View_of_the_Spine from '../../../assets/iconsPlans/Coronal_View_of_the_Spine.png';
import Fetal_Abdominal_Standard_Plane from '../../../assets/iconsPlans/Fetal_Abdominal_Standard_Plane.png';
import Axial_View_of_Kidneys from '../../../assets/iconsPlans/Axial_View_of_Kidneys.png';
import Axial_View_of_Fetal_Bladder from '../../../assets/iconsPlans/Axial_View_of_Fetal_Bladder.png';
import View_of_Upper_Limb from '../../../assets/iconsPlans/View_of_Upper_Limb.png';
import View_of_Lower_Limb from '../../../assets/iconsPlans/View_of_Lower_Limb.png';
import Femur_Plane from '../../../assets/iconsPlans/Femur_Plane.png';
import View_of_Genitalia from '../../../assets/iconsPlans/View_of_Genitalia.png';
import Sagittal_View_of_Cervix_with_Placenta from '../../../assets/iconsPlans/Sagittal_View_of_Cervix_with_Placenta.png';
import Sagittal_View_for_CRL_and_NC_Measurements from '../../../assets/iconsPlans/Sagittal_View_for_CRL_and_NC_Measurements.png';

// --- Dark Mode Image Imports (assuming filenames end with _dark) ---
import Four_Chamber_View_of_the_Heart_dark from '../../../assets/iconsPlans/Four_Chamber_View_of_the_Heart_dark.png';
import LVOT_dark from '../../../assets/iconsPlans/LVOT_dark.png';
import RVOT_dark from '../../../assets/iconsPlans/RVOT_dark.png';
import Three_Vessel_View_dark from '../../../assets/iconsPlans/Three_Vessel_View_dark.png';
import Three_Vessel_View_Trachea_dark from '../../../assets/iconsPlans/Three_Vessel_View_Trachea_dark.png';
import Transventricular_View_dark from '../../../assets/iconsPlans/Transventricular_View_dark.png';
import Transthalamic_View_dark from '../../../assets/iconsPlans/Transthalamic_View_dark.png';
import Transcerebellar_View_dark from '../../../assets/iconsPlans/Transcerebellar_View_dark.png';
import Sagittal_View_of_the_Brain_dark from '../../../assets/iconsPlans/Sagittal_View_of_the_Brain_dark.png';
import Sagittal_View_of_the_Face_dark from '../../../assets/iconsPlans/Sagittal_View_of_the_Face_dark.png';
import Coronal_View_of_Upper_Lip_Nose_Nostrils_dark from '../../../assets/iconsPlans/Coronal_View_of_Upper_Lip_Nose_Nostrils_dark.png';
import Sagittal_View_of_the_Entire_Spine_dark from '../../../assets/iconsPlans/Sagittal_View_of_the_Entire_Spine_dark.png';
import Coronal_View_of_the_Spine_dark from '../../../assets/iconsPlans/Coronal_View_of_the_Spine_dark.png';
import Fetal_Abdominal_Standard_Plane_dark from '../../../assets/iconsPlans/Fetal_Abdominal_Standard_Plane_dark.png';
import Axial_View_of_Kidneys_dark from '../../../assets/iconsPlans/Axial_View_of_Kidneys_dark.png';
import Axial_View_of_Fetal_Bladder_dark from '../../../assets/iconsPlans/Axial_View_of_Fetal_Bladder_dark.png';
import View_of_Upper_Limb_dark from '../../../assets/iconsPlans/View_of_Upper_Limb_dark.png';
import View_of_Lower_Limb_dark from '../../../assets/iconsPlans/View_of_Lower_Limb_dark.png';
import Femur_Plane_dark from '../../../assets/iconsPlans/Femur_Plane_dark.png';
import View_of_Genitalia_dark from '../../../assets/iconsPlans/View_of_Genitalia_dark.png';
import Sagittal_View_of_Cervix_with_Placenta_dark from '../../../assets/iconsPlans/Sagittal_View_of_Cervix_with_Placenta_dark.png';
import Sagittal_View_for_CRL_and_NC_Measurements_dark from '../../../assets/iconsPlans/Sagittal_View_for_CRL_and_NC_Measurements_dark.png';
import Orbits_View_dark from '../../../assets/iconsPlans/orbits_dark.png';
import Orbits_View from '../../../assets/iconsPlans/orbits.png';


// In your types file (e.g., ../types/planes.types)
interface PlaneConfig {
  label: string;
  tag: string;
  defaultImage: string; // Or whatever type the imported image is
  darkImage: string;     // Add this new property
}
export const PLANES_CONFIGS: PlaneConfig[] = [
    // --- Heart Views ---
    {
      label: 'Four Chamber View',
      tag: 'VIEW__4CH',
      defaultImage: Four_Chamber_View_of_the_Heart,
      darkImage: Four_Chamber_View_of_the_Heart_dark,
    },
    {
      label: 'LVOT View',
      tag: 'VIEW__LVOT',
      defaultImage: LVOT,
      darkImage: LVOT_dark,
    },
    {
      label: 'RVOT View',
      tag: 'VIEW__RVOT',
      defaultImage: RVOT,
      darkImage: RVOT_dark,
    },
    {
      label: 'Three Vessel View',
      tag: 'VIEW__ThreeVesselView',
      defaultImage: Three_Vessel_View,
      darkImage: Three_Vessel_View_dark,
    },
    {
      label: 'Three Vessel & Trachea View',
      tag: 'VIEW__three_vessel_trachea',
      defaultImage: Three_Vessel_View_Trachea,
      darkImage: Three_Vessel_View_Trachea_dark,
    },
    // --- Brain & Head Views ---
    {
      label: 'Transventricular View',
      tag: 'VIEW__Transventricular',
      defaultImage: Transventricular_View,
      darkImage: Transventricular_View_dark,
    },
    {
      label: 'Transthalamic View',
      tag: 'VIEW__Transthalamic',
      defaultImage: Transthalamic_View,
      darkImage: Transthalamic_View_dark,
    },
    {
      label: 'Transcerebellar View',
      tag: 'VIEW__Transcerebellar',
      defaultImage: Transcerebellar_View,
      darkImage: Transcerebellar_View_dark,
    },
    {
      label: 'Sagittal Brain View',
      tag: 'VIEW__sagittal_brain',
      defaultImage: Sagittal_View_of_the_Brain,
      darkImage: Sagittal_View_of_the_Brain_dark,
    },
    // --- Face Views ---
    {
      label: 'Sagittal Face View',
      tag: 'VIEW__sagittal_view_of_the_face',
      defaultImage: Sagittal_View_of_the_Face,
      darkImage: Sagittal_View_of_the_Face_dark,
    },
    {
      label: 'Coronal Upper Lip View',
      tag: 'VIEW__upper_lip',
      defaultImage: Coronal_View_of_Upper_Lip_Nose_Nostrils,
      darkImage: Coronal_View_of_Upper_Lip_Nose_Nostrils_dark,
    },
    // --- Spine Views ---
    // {
    //   label: 'Sagittal Spine View',
    //   tag: 'VIEW__SagittalViewOfTheEntireSpine',
    //   defaultImage: Sagittal_View_of_the_Entire_Spine,
    //   darkImage: Sagittal_View_of_the_Entire_Spine_dark,
    // },
    {
      label: 'Coronal Spine View',
      tag: 'VIEW__coronal_spine',
      defaultImage: Coronal_View_of_the_Spine,
      darkImage: Coronal_View_of_the_Spine_dark,
    },
    // --- Abdominal & Organ Views ---
    {
      label: 'Fetal Abdominal Standard Plane',
      tag: 'VIEW__FetalAbdominalStandardPlane',
      defaultImage: Fetal_Abdominal_Standard_Plane,
      darkImage: Fetal_Abdominal_Standard_Plane_dark,
    },
    {
      label: 'Axial Kidneys View',
      tag: 'VIEW__AxialViewOfKidneys',
      defaultImage: Axial_View_of_Kidneys,
      darkImage: Axial_View_of_Kidneys_dark,
    },
    {
      label: 'Axial Fetal Bladder View',
      tag: 'VIEW__AxialViewOfFetalBladder',
      defaultImage: Axial_View_of_Fetal_Bladder,
      darkImage: Axial_View_of_Fetal_Bladder_dark,
    },
    // --- Limbs & Measurements ---
    {
      label: 'Upper Limb View',
      tag: 'VIEW__UpperLimb',
      defaultImage: View_of_Upper_Limb,
      darkImage: View_of_Upper_Limb_dark,
    },
    {
      label: 'Lower Limb View',
      tag: 'VIEW__LowerLimb',
      defaultImage: View_of_Lower_Limb,
      darkImage: View_of_Lower_Limb_dark,
    },
    {
      label: 'Femur (Femoral) Plane',
      tag: 'VIEW__Femoral',
      defaultImage: Femur_Plane,
      darkImage: Femur_Plane_dark,
    },
    // --- Other/Specialized Views ---
    {
      label: 'Genitalia View',
      tag: 'VIEW__genitalia',
      defaultImage: View_of_Genitalia,
      darkImage: View_of_Genitalia_dark,
    },
    {
      label: 'Cervix & Placenta View',
      tag: 'VIEW__SagittalViewOfCervixWithPlacenta',
      defaultImage: Sagittal_View_of_Cervix_with_Placenta,
      darkImage: Sagittal_View_of_Cervix_with_Placenta_dark,
    },
    {
      label: 'Crown-Rump Length View',
      tag: 'VIEW__CrownRumpLengthView',
      defaultImage: Sagittal_View_for_CRL_and_NC_Measurements,
      darkImage: Sagittal_View_for_CRL_and_NC_Measurements_dark,
    },
    {
      label: 'Orbits View',
      tag: 'VIEW__Orbits',
      defaultImage: Orbits_View,
      darkImage: Orbits_View_dark,
    },
    // Add other planes here in the same format if needed...
  ];